// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__1lLdu","header":"styles_header__2e_TM","back":"styles_back__1xFzM","title":"styles_title__1Xnua","content":"styles_content__nTVfV"};